// eslint-disable-next-line @typescript-eslint/no-empty-function
if (process.env.NODE_ENV === 'production') console.log = function () {};
// // eslint-disable-next-line @typescript-eslint/no-empty-function
// console.log = function () {};